import {
  STAKING_HISTORY_KEYS,
  STAKING_HISTORY_SORT_TYPES,
  sortKeys,
} from '../../pages/Staking/stakingConstants';
import * as types from './stakingActionTypes';

const initialState = {
  //dummy staking history data
  stakingHistoryData: null,
  stakingStatisticsData: null,
  stakingHistorySortData: {
    sortType: STAKING_HISTORY_SORT_TYPES.DESCENDING,
    sortKey: STAKING_HISTORY_KEYS.DATE,
  },
  postedStake: null,
  error: {
    type: null,
    data: null,
  },
};

const getSortValue = (item, key) => {
  switch (key) {
    case 'date':
      return new Date(item.udate);
    case 'value':
      return parseFloat(item.value) || 0;
    case 'name':
      return item.name || '';
    default:
      return new Date(item.udate);
  }
};

export const stakingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_STAKING_HISTORY_DATA: {
      const stakingHistoryData = action?.payload.result?.staked_tokens || [];
    
      const sortedStakingHistoryData = [...stakingHistoryData].sort((a, b) => {
        const dateA = new Date(a.udate);
        const dateB = new Date(b.udate);
        return dateB - dateA;
      });
    
      return {
        ...state,
        stakingHistoryData: sortedStakingHistoryData,
        stakingHistorySortData: {
          ...state.stakingHistorySortData,
          sortType: STAKING_HISTORY_SORT_TYPES.DESCENDING,
          sortKey: STAKING_HISTORY_KEYS.DATE,
        },
      };
    }
    case types.GET_STAKING_HISTORY_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_STAKING_HISTORY_ERROR,
          data: action.payload.result,
        },
      };
    case types.GET_STAKING_STATISTICS_DATA:
      return {
        ...state,
        stakingStatisticsData: action?.payload.result ? { ...action?.payload.result } : null,
      };
    case types.GET_STAKING_STATISTICS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_STAKING_STATISTICS_ERROR,
          data: action.payload.result,
        },
      };
    case types.POST_STAKING_DATA:
      return {
        ...state,
        postedStake: action?.payload.result ? { ...action?.payload.result } : null,
      };
    case types.POST_STAKING_ERROR:
      return {
        ...state,
        error: {
          type: types.POST_STAKING_ERROR,
          data: action.payload.result,
        },
      };

    case types.PUT_STAKING_DATA:
      return {
        ...state,
        putStake: action?.payload ? { ...action?.payload.result } : null,
      };
    case types.PUT_STAKING_ERROR:
      return {
        ...state,
        error: {
          type: types.PUT_STAKING_ERROR,
          data: action.payload.result,
        },
      };
    case types.SET_STAKING_HISTORY_SORT_DATA:
      return {
        ...state,
        stakingHistorySortData: { ...action.payload.result },
      };
    case types.SORTING_STAKING_HISTORY: {
      if (!state.stakingHistoryData || !Array.isArray(state.stakingHistoryData)) {
        return state;
      }

      const { sortKey, sortType } = state.stakingHistorySortData;
      if (sortKey === undefined || sortKey === null || !sortKeys[sortKey]) {
        return state;
      }

      const selectedKey = sortKeys[sortKey].key;
      const stakingHistoryData = [...state.stakingHistoryData];
      
      const sortedStakingHistoryData = stakingHistoryData.sort((a, b) => {
        const valueA = getSortValue(a, selectedKey);
        const valueB = getSortValue(b, selectedKey);

        let comparison = 0;
        
        if (selectedKey === 'date') {
          comparison = valueA - valueB;
        } else if (selectedKey === 'value') {
          comparison = valueA - valueB;
        } else if (selectedKey === 'name') {
          comparison = valueA.localeCompare(valueB);
        }

        if (sortType === STAKING_HISTORY_SORT_TYPES.DESCENDING) {
          comparison = -comparison;
        }

        return comparison;
      });
      
      return {
        ...state,
        stakingHistoryData: sortedStakingHistoryData,
      };
    }
    default:
      return state;
  }
};